'use client';

import LoadingHandler from "@components/LoadingHandler";
import { Navbar } from "@components/navbar";
import { useLocalStore } from '@store/useLocalStore';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function RoleProvider({ children }) {
    const { token, role: userRole } = useLocalStore((state) => state.user);
    const router = useRouter();
    const pathname = usePathname();

    const isGoingToPro = pathname.startsWith('/pro');
    const isGoingToParticulier = pathname.startsWith('/particulier');
    const isGoingToCapture = pathname.startsWith('/page-de-capture');
    const isGoingToTunnel = pathname.startsWith('/tunnel');

    useEffect(() => {
        if (!token && (isGoingToPro || isGoingToParticulier)) {
            router.push('/connexion');
            return
        };
        if (router && pathname) {
            if (userRole === 'pros' && isGoingToParticulier) {
                router.push('/pro/mon-espace');
            } else if (userRole === 'client' && isGoingToPro) {
                router.push('/particulier/mon-espace');
            }
        }
    }, [userRole, router, pathname]);

    const marginClass = (isGoingToParticulier || isGoingToPro) ? "lg:ml-24 " : "";
    const displayClass = (isGoingToCapture || isGoingToTunnel) ? "block" : "flex";
    return (
        <div className="flex size-full min-h-screen flex-col bg-mainBg lg:flex-row">
            <Navbar />
            <div className={`relative ${marginClass} ${displayClass}  size-full flex-col flex-wrap items-center gap-y-4 overflow-auto p-4 text-primaryText lg:h-screen lg:max-h-screen lg:flex-row lg:items-start lg:gap-0 2xl:justify-center`}>
                <LoadingHandler>
                    {children}
                </LoadingHandler>
            </div>
        </div>
    );
}